import React from 'react'
import { useTranslation } from 'react-i18next'
import InspectorSectionTitle from '@/components/InspectorGrid/InspectorSectionTitle'
import InspectorGrid, { GridSize } from '@/components/InspectorGrid/InspectorGrid'
import InspectorGridButton from '@/components/InspectorGrid/InspectorGridButton'
import Icons from '../../../Icons'

export type CropAspectRatioId = 'freeform' | 'square' | 'landscape' | 'portrait'

export interface CropRatioOption {
  id: CropAspectRatioId
  titleKey: string
  icon: React.ComponentType
  /** width / height, or null for freeform. */
  aspectRatio: number | null
}

export const CROP_RATIO_OPTIONS: readonly CropRatioOption[] = [
  { id: 'freeform', titleKey: 'Freeform', icon: Icons.RatioFreeform, aspectRatio: null },
  { id: 'square', titleKey: 'Square', icon: Icons.RatioSquare, aspectRatio: 1 },
  { id: 'landscape', titleKey: 'Landscape', icon: Icons.RatioLandscape, aspectRatio: 16 / 9 },
  { id: 'portrait', titleKey: 'Portrait', icon: Icons.RatioPortrait, aspectRatio: 9 / 16 },
]

export interface CropRatioOptionsProps {
  selectedRatioId: CropAspectRatioId
  onSelectRatio: (option: CropRatioOption) => void
}

/**
 * Pure Ratio section of the crop inspector. No editor context — the editor's
 * Crop panel and Batch crop each apply the chosen ratio themselves.
 */
function CropRatioOptions({ selectedRatioId, onSelectRatio }: CropRatioOptionsProps) {
  const { t } = useTranslation()
  return (
    <>
      <InspectorSectionTitle title={t('Ratio')} />
      <InspectorGrid gridSize={GridSize.Grid3}>
        {CROP_RATIO_OPTIONS.map((option) => (
          <InspectorGridButton
            gridSize={GridSize.Grid3}
            key={option.id}
            title={t(option.titleKey)}
            onClick={() => onSelectRatio(option)}
            selected={selectedRatioId === option.id}
          >
            <option.icon />
          </InspectorGridButton>
        ))}
      </InspectorGrid>
    </>
  )
}

export default CropRatioOptions
